export default [
  {
    path: '/card_link/:center_id/:token/',
    name: 'card_link',
    component: () => import('@/views/pages/credit_card_link.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/payment/:student_uuid/:date/',
    name: 'schedule-payment',
    component: () => import('@/views/pages/payment.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
   {
    path: '/transaction-payment/:transaction_uuid/',
    name: 'transaction-payment',
    component: () => import('@/views/pages/payment-transaction.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/payment-status/:order_id/',
    name: 'payment-status',
    component: () => import('@/views/pages/payment-status.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/center',
    name: 'center',
    component: () => import('@/views/cloudfit/center/change.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/pay_link/:paylink_token/',
    name: 'paylink',
    component: () => import('@/views/pages/pay_link.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/signature/:expire_token/',
    name: 'signature',
    component: () => import('@/views/pages/signature.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/register/:initial/:center_code/',
    name: 'register',
    component: () => import('@/views/pages/register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/epad/:id',
    name: 'epad',
    component: () => import('@/views/cloudfit/epad/Epad.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/cloudfit/dashboard/Ecommerce.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
    {
    path: '/student-dashboard',
    name: 'student-dashboard',
    component: () => import('@/views/cloudfit/dashboard/student-dashboard.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/album-list',
    name: 'album-list',
    component: () => import('@/views/cloudfit/album/album-list.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/goal',
    name: 'goal',
    component: () => import('@/views/cloudfit/goals/goal_list.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/offer-list',
    name: 'offer-list',
    component: () => import('@/views/cloudfit/offer/offer_list.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/product-set-list',
    name: 'product-set-list',
    component: () => import('@/views/cloudfit/offer/ProductSetList.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/pt-detail/:id',
    name: 'pt-detail',
    component: () => import('@/views/cloudfit/package/Pt_Detail.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@/views/cloudfit/calendar/Calendar.vue'),
    meta: {
    resource: 'ACL',
      action: 'read',
    }
  },
  {
    path: '/student-list',
    name: 'student-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Student List 學生管理',
      breadcrumb: [
        {
          text: 'Student List 學生管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/staff-list',
    name: 'staff-list',
    component: () => import('@/views/cloudfit/staff/staff_list.vue'),
    meta: {
      pageTitle: 'User List 系統用戶管理',
      breadcrumb: [
        {
          text: 'User List 系統用戶管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/group-list',
    name: 'group-list',
    component: () => import('@/views/group/group_list.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/staff/edit/:id',
    name: 'apps-staff-edit',
    component: () => import('@/views/cloudfit/staff/staff-edit/StaffEdit.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/cloudfit/membership/:id',
    name: 'apps-membership',
    component: () => import('@/views/cloudfit/member/member-edit/membership-edit.vue'),
    meta: {
      pageTitle: 'Plan Detail',
      breadcrumb: [
        {
          text: 'Plan Detail',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/cloudfit/package/:id',
    name: 'apps-package',
    component: () => import('@/views/cloudfit/package/Package.vue'),
    meta: {
      pageTitle: 'Package Record',
      breadcrumb: [
        {
          text: 'Package Record',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/cloudfit/staff/package/:id',
    name: 'apps-package',
    component: () => import('@/views/cloudfit/staff/Package.vue'),
    meta: {
      pageTitle: 'Staff Package Record',
      breadcrumb: [
        {
          text: 'Staff Package Record',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/student/edit/:id',
    name: 'apps-student-edit',
    component: () => import('@/views/cloudfit/member/member-edit/MemberEdit.vue'),
    meta: {
      pageTitle: 'Student Info 學生資料',
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/:id/class/add/',
    name: 'apps-member-class-add',
    component: () => import('@/views/cloudfit/member/class/add.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/:id/invoice/add/',
    name: 'apps-member-inovice-add',
    component: () => import('@/views/cloudfit/member/invoice/invoice-add.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/apps/member/:id/membership/add/',
    name: 'apps-member-membership-add',
    component: () => import('@/views/cloudfit/member/membership/add.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/news-list',
    name: 'news-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/package-list',
    name: 'package-list',
    component: () => import('@/views/cloudfit/package/package_list.vue'),
    meta: {
      pageTitle: 'Package List 套票管理',
      breadcrumb: [
        {
          text: 'Package List 套票管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/membership-list',
    name: 'membership-list',
    component: () => import('@/views/cloudfit/membership/membership_list.vue'),
    meta: {
      pageTitle: 'Membership List 會籍管理',
      breadcrumb: [
        {
          text: 'Membership List 會籍管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/class-import',
    name: 'class-import',
    component: () => import('@/views/cloudfit/class/Import.vue'),
    meta: {
      pageTitle: 'Import',
      breadcrumb: [
        {
          text: 'Import',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/system-config',
    name: 'system-config',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/class-list',
    name: 'class-list',
    component: () => import('@/views/cloudfit/class/Class.vue'),
    meta: {

      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/slider',
    name: 'slider',
    component: () => import('@/views/cloudfit/slider/slider.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: () => import('@/views/cloudfit/product/product.vue'),
    meta: {
      pageTitle: 'Product List 貨品管理',
      breadcrumb: [
        {
          text: 'Product List 貨品管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/short-course-list',
    name: 'short-course-list',
    component: () => import('@/views/cloudfit/short-course/short-course.vue'),
    meta: {
      pageTitle: 'Short Course List 短期課程管理',
      breadcrumb: [
        {
          text: 'Short Course List 短期課程管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/coupon-list',
    name: 'coupon-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/product-list',
    name: 'product-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/center-list',
    name: 'center-list',
    component: () => import('@/views/cloudfit/member/member_list.vue'),
    meta: {
      pageTitle: 'Member List 會員管理',
      breadcrumb: [
        {
          text: 'Member List 會員管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/room-list',
    name: 'room-list',
    component: () => import('@/views/cloudfit/room/Room.vue'),
    meta: {
      pageTitle: 'Room List 課室管理',
      breadcrumb: [
        {
          text: 'Room List 課室管理',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/interest-class',
    name: 'report-interest-class',
    component: () => import('@/views/cloudfit/report/Report-applied-application.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/class-income',
    name: 'report-class-income',
    component: () => import('@/views/cloudfit/report/Report-class-income.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/hold-workshop',
    name: 'report-hold-workshop',
    component: () => import('@/views/cloudfit/report/Report-hold-workshop.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/online-payment',
    name: 'report-online-payment',
    component: () => import('@/views/cloudfit/report/Report-stripe.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/sales-monthly',
    name: 'report-sales-monthly',
    component: () => import('@/views/cloudfit/report/Report-sales-monthly.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/group',
    name: 'report-group',
    component: () => import('@/views/cloudfit/report/Report-group.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/split',
    name: 'report-split',
    component: () => import('@/views/cloudfit/report/Report-split.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/user-commission',
    name: 'report-user-commission',
    component: () => import('@/views/cloudfit/report/Report-user-commission.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/product',
    name: 'report-product',
    component: () => import('@/views/cloudfit/report/Report-product.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/teacher',
    name: 'report-teacher',
    component: () => import('@/views/cloudfit/report/Report-teacher.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/center-Sales.vue',
    name: 'report-center-sales',
    component: () => import('@/views/cloudfit/report/Report-daily-sales-center.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/report-expire-student',
    name: 'report-expire-student',
    component: () => import('@/views/cloudfit/report/Report-expire-student.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/trial_and_newjoin',
    name: 'report-trial-and-newjoin',
    component: () => import('@/views/cloudfit/report/Report-trial-and-newjoin.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report/:code',
    name: 'report',
    component: () => import('@/views/cloudfit/report/Report.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-paymentMethod',
    name: 'reportPaymentMethod',
    component: () => import('@/views/cloudfit/report/Report-payment-method.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-transacion',
    name: 'report-transacion',
    component: () => import('@/views/cloudfit/report/Report-transaction.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-student',
    name: 'report-student',
    component: () => import('@/views/cloudfit/report/Report-student.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-installment',
    name: 'report-installment',
    component: () => import('@/views/cloudfit/report/Report-installment.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-entry',
    name: 'report-entry',
    component: () => import('@/views/cloudfit/report/Report-entry.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-commission',
    name: 'report-commission',
    component: () => import('@/views/cloudfit/report/Report-commission.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-membership',
    name: 'report-membership',
    component: () => import('@/views/cloudfit/report/Report-membership.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-online-payment',
    name: 'report-online-payment',
    component: () => import('@/views/cloudfit/report/Report-online-payment.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-nonpay',
    name: 'report-nonpay',
    component: () => import('@/views/cloudfit/report/Report-nonpay.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/report-personal-training',
    name: 'report-personal-training',
    component: () => import('@/views/cloudfit/report/Report-pt.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Report',
          active: true,
        },
      ],
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/expenditure',
    name: 'expenditure',
    component: () => import('@/views/cloudfit/expenditure/expenditure-list.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
  {
    path: '/invoice',
    name: 'invoice',
    component: () => import('@/views/cloudfit/invoice/invoice-list.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
]
